<template>
  <v-tabs
    v-model="tab"
    background-color="white"
    prev-icon="mdi-arrow-left-bold-box-outline"
    next-icon="mdi-arrow-right-bold-box-outline"
  >
    <v-tabs-slider></v-tabs-slider>

    <v-tab
      v-for="tabItem in filteredTabs"
      :key="tabItem.key"
      :href="`#${tabItem.key}`"
    >
      <v-badge
        color="primary"
        :content="isHistoryEvent ? 0 : $store.get(tabItem.diffGetter)"
        :value="isHistoryEvent ? 0 : $store.get(tabItem.diffGetter)"
      >
        {{ tabItem.name }}
      </v-badge>
    </v-tab>

    <v-tab-item
      v-for="tabItem in filteredTabs"
      :key="tabItem.key"
      :value="tabItem.key"
    >
      <v-divider />
      <component :is="tabItem.component" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import TrafficMessageContainer from '@/modules/trafficMessage/components/TrafficMessageContainer'
import DuaMessageContainer from '@/modules/duaMessage/components/DuaMessageContainer'
import { get } from 'vuex-pathify'
import SmsMessageContainer from '../modules/smsMessage/components/SmsMessageContainer.vue'

export default {
  name: 'OutputTabs',

  data: () => ({
    tab: 'trafficMessage',
    tabs: [
      {
        name: 'Trafikmeddelanden',
        key: 'trafficMessage',
        diffGetter: 'trafficMessage/diffItemsCount',
        component: TrafficMessageContainer
      },
      {
        name: 'DUA',
        key: 'duaMessage',
        diffGetter: 'duaMessage/diffItemsCount',
        component: DuaMessageContainer
      },
      {
        name: 'SMS',
        key: 'sms',
        diffGetter: 'smsMessage/diffItemsCount',
        component: SmsMessageContainer
      }
    ]
  }),

  computed: {
    selectedDistrictId: get('app/selectedDistrictId'),

    user() {
      return this.$store.get('sso/user')
    },

    filteredTabs() {
      const isTib = [17, 19].includes(this.selectedDistrictId)
      return this.tabs.filter(x => {
        if (x.key === 'sms') {
          return isTib
        }

        return true
      })
    },
    isHistoryEvent: get('history/isHistoryEvent')
  }
}
</script>
